(function() {
  // ------------------------
  // Popup function
  // ------------------------
  window.showAddToCartPopup = function(product) {
    const popup = document.getElementById('add-to-cart-popup');
    if (!popup) return;

    // Show popup
    popup.classList.remove('hidden');
    setTimeout(() => popup.classList.add('hidden'), 4000);

    // Update header cart count
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then(r => r.json())
      .then(cart => {
        const cartCountEl = document.querySelector('.cart-link__bubble-num');
        if (cartCountEl) {
          cartCountEl.textContent = cart.item_count;
          const bubble = cartCountEl.closest('.cart-link__bubble');
          if (bubble) bubble.style.display = cart.item_count > 0 ? 'inline-block' : 'none';
        }
      });
  };

  document.addEventListener('click', (e) => {
  if (e.target.matches('#add-to-cart-popup .continue-btn')) {
    const popup = document.getElementById('add-to-cart-popup');
    if (popup) popup.classList.add('hidden');
  }
});


  // ------------------------
  // Intercept product page Add to Cart forms
  // ------------------------
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    e.preventDefault();
    e.stopPropagation();

    const formData = new FormData(form);

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
    .then(res => {
      if (!res.ok) throw res;
      return res.json();
    })
    .then(product => {
      window.showAddToCartPopup(product);
    })
    .catch(err => {
      console.error('Add to cart failed', err);
      alert('Sorry, we couldn’t add that to your cart. Please try again.');
    });
    document.addEventListener('ajaxProduct:added', function(e) {
  const product = e.detail?.product;
  if (product && window.showAddToCartPopup) {
    window.showAddToCartPopup(product);
  }
});
  }, true); // capture phase to intercept before theme

document.addEventListener('ajaxProduct:added', function (e) {
  const product = e.detail?.product;
  if (product) {
    window.showAddToCartPopup(product);
  }
});

})();